//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { getClientCampaign } from '@apis/campaign-requests/sampling/campaigns/samplingCampaignsApi';

/**
 * AngularJS service for determining how to display campaign information based on user's relationship to the campaign.
 *
 * BUSINESS RULES:
 * 1. REGULAR CAMPAIGNS: Normal campaigns created by the current user
 *    - Show all features
 *
 * 2. RETAILER CAMPAIGNS - BRAND POV: Brand viewing their retailer campaign
 *    - Limited access - only showing Details tab
 *
 * 3. RETAILER CAMPAIGNS - RETAILER POV: Retailer viewing assigned campaign
 *    - Full access to all features
 */

(function () {
  const curalate = angular.module('curalate');

  curalate.service('CampaignPerspectiveService', [
    'SessionVarsService',
    function (SessionVarsService) {
      this.getCampaignData = function (campaignId) {
        return getClientCampaign({ campaignId: campaignId });
      };

      /**
       * Determines if the current user is a brand viewing a retailer campaign
       */
      this.isViewerTheBrand = function (campaignData) {
        if (!campaignData || !campaignData.requestorClientId) {
          return false; // Regular campaign
        }

        const currentUserClient = SessionVarsService.getClientName();
        return currentUserClient === campaignData.requestorClientId;
      };

      /**
       * Main method to determine if the current view is from a brand's perspective
       */
      this.isBrandPerspectiveView = function (campaignId) {
        const self = this;

        if (!campaignId) {
          return Promise.resolve(false);
        }

        return this.getCampaignData(campaignId)
          .then(function (campaignData) {
            // Return true if brand is viewing retailer campaign (restricted view)
            return self.isViewerTheBrand(campaignData);
          })
          .catch(function () {
            return false;
          });
      };
    },
  ]);
})();
